import { getConditionalObject } from 'utils/data';

export const normalizeForm = ({ form, entityId }) => {
  const {
    isBorrowerCompletedHomeownershipEducation,
    borrowerHomeownershipEducationFormat,
    homeownershipEducationHousingCounselingAgencyIdNumber,
    homeownershipEducationHousingCounselingAgencyName,
    homeownershipEducationHousingCounselingAgencyState,
    homeownershipEducationHousingCounselingAgencyCity,
    homeownershipEducationHousingCounselingAgencyAddress1,
    homeownershipEducationHousingCounselingAgencyAddress2,
    homeownershipEducationHousingCounselingAgencyZip,
    homeownershipEducationNameOfTheHousingEducationProgram,
    dateOfCompletionHomeownershipEducation,
    isBorrowerCompletedHousingCounseling,
    borrowerHousingCounselingFormat,
    housingCounselingAgencyIdNumber,
    housingCounselingAgencyName,
    housingCounselingAgencyState,
    housingCounselingAgencyCity,
    housingCounselingAgencyAddress1,
    housingCounselingAgencyAddress2,
    housingCounselingAgencyZip,
    housingCounselingNameOfTheHousingEducationProgram,
    dateOfCompletionHousingCounseling,
  } = form[entityId]?.declarations?.homeownershipEducationAndHousingCounseling ?? {};

  return {
    ...form,
    [entityId]: {
      ...form[entityId],
      declarations: {
        ...form[entityId]?.declarations,
        homeownershipEducationAndHousingCounseling: {
          isBorrowerCompletedHomeownershipEducation,

          ...getConditionalObject(isBorrowerCompletedHomeownershipEducation, {
            borrowerHomeownershipEducationFormat,
            homeownershipEducationHousingCounselingAgencyIdNumber,
            homeownershipEducationHousingCounselingAgencyName,
            homeownershipEducationHousingCounselingAgencyState,
            homeownershipEducationHousingCounselingAgencyCity,
            homeownershipEducationHousingCounselingAgencyAddress1,
            homeownershipEducationHousingCounselingAgencyAddress2,
            homeownershipEducationHousingCounselingAgencyZip,
            homeownershipEducationNameOfTheHousingEducationProgram:
              !homeownershipEducationHousingCounselingAgencyName
                ? (homeownershipEducationNameOfTheHousingEducationProgram ?? undefined)
                : null,
            dateOfCompletionHomeownershipEducation,
          }),

          isBorrowerCompletedHousingCounseling,

          ...getConditionalObject(isBorrowerCompletedHousingCounseling, {
            borrowerHousingCounselingFormat,
            housingCounselingAgencyIdNumber,
            housingCounselingAgencyName,
            housingCounselingAgencyState,
            housingCounselingAgencyCity,
            housingCounselingAgencyAddress1,
            housingCounselingAgencyAddress2,
            housingCounselingAgencyZip,
            housingCounselingNameOfTheHousingEducationProgram: !housingCounselingAgencyName
              ? (housingCounselingNameOfTheHousingEducationProgram ?? undefined)
              : null,
            dateOfCompletionHousingCounseling,
          }),
        },
      },
    },
  };
};
